/**
 * PageEditor Surface Component
 * Rich text editor for page content
 */

import React, { useState } from 'react';
import { Stack, Title, Textarea, Group, Button, Badge, Text, Paper } from '@mantine/core';
import { IconDeviceFloppy, IconTrash } from '@tabler/icons-react';

interface PageEditorProps {
  phase?: number;
  currentPageId?: string;
}

const PageEditor: React.FC<PageEditorProps> = ({ phase = 4, currentPageId }) => {
  const [content, setContent] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    await new Promise(resolve => setTimeout(resolve, 500));
    console.log('Page saved:', currentPageId, content);
    setIsSaving(false);
  };

  return (
    <Stack gap="md" p="md">
      <Group justify="space-between" align="center">
        <div>
          <Title order={3}>Page Editor</Title>
          <Text size="xs" c="dimmed">
            {currentPageId ? `Editing: ${currentPageId}` : 'Create or edit page content'}
          </Text>
        </div>
        <Group>
          <Badge size="lg" variant="light" color="violet">Phase {phase}</Badge>
          <Button
            leftSection={<IconDeviceFloppy size={16} />}
            onClick={handleSave}
            loading={isSaving}
            variant="filled"
          >
            Save
          </Button>
        </Group>
      </Group>

      <Paper p="md" radius="md" withBorder style={{ minHeight: 400 }}>
        <Textarea
          placeholder="Start writing your page content here..."
          value={content}
          onChange={(e) => setContent(e.currentTarget.value)}
          minRows={15}
          autosize
          variant="unstyled"
          styles={{
            input: {
              fontSize: '16px',
              lineHeight: '1.6',
              minHeight: 300
            }
          }}
        />
      </Paper>

      <Group justify="flex-end">
        <Button
          variant="subtle"
          color="red"
          leftSection={<IconTrash size={16} />}
        >
          Delete Page
        </Button>
      </Group>
    </Stack>
  );
};

export default PageEditor;